import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettyprint'
})

  //https://stackoverflow.com/questions/37308420/angular-2-pipe-that-transforms-json-object-to-pretty-printed-json
export class PrettyPrintJsonPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    return JSON.stringify(value, null, 2)
      //.replace(' ', '&nbsp;')
      //.replace('\n', '<br/>');
  }

}
